import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../../../../utils/form";
import {
    createColumnInlineInputNumber,
    createColumnInlineRadioGroup, createColumnInlineTextArea
} from "../../../../../../components/table/c-table.logic";
import i18n from "../../../../../../i18n";
import { callResultType } from "../request.logic";

export const createColumns = ({ props, data }) => {
    const { viewOnly, itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const columns = [];
    columns.push(
        createColumnInlineTextArea({
            title: () => i18n.global.t("views.request.releaseResultProduct.invoiceCode"),
            dataIndex: "refInspectionProduct.refInformProduct.invoiceCode",
            items,
            useForm,
            itemsKey,
            width: 120,
            sorter: false,
            customRenderInputProp: ({ key }) => lodash.merge(
                {
                    disabled: true,
                    rows: 1,
                    autoSize: true,
                },
                conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
            )
        }),
        createColumnInlineInputNumber({
            title: () => i18n.global.t("views.request.releaseResultProduct.invoiceSeq"),
            dataIndex: "refInspectionProduct.refInformProduct.invoiceSeq",
            items,
            useForm,
            itemsKey,
            width: 50,
            sorter: false,
            customRenderInputProp: ({ key }) => lodash.merge(
                {
                    disabled: true
                },
                conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
            )
        }),
        createColumnInlineTextArea({
            title: () => i18n.global.t("views.request.releaseResultProduct.refHazObject"),
            dataIndex: "refInspectionProduct.refInformProduct.refHazObject.nameTh",
            items,
            useForm,
            itemsKey,
            width: 180,
            sorter: false,
            customRenderInputProp: ({ key }) => lodash.merge(
                {
                    disabled: true,
                    rows: 1,
                    autoSize: true,
                },
                conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
            )
        }),
        createColumnInlineTextArea({
            title: () => i18n.global.t("views.request.releaseResultProduct.manufacturer"),
            dataIndex: "refInspectionProduct.refInformProduct.manufacturer",
            items,
            useForm,
            itemsKey,
            width: 150,
            sorter: false,
            customRenderInputProp: ({ key }) => lodash.merge(
                {
                    disabled: true,
                    rows: 1,
                    autoSize: true,
                },
                conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
            )
        }),
        createColumnInlineInputNumber({
            title: () => i18n.global.t("views.request.releaseResultProduct.numberOfPackage"),
            dataIndex: "numberOfPackage",
            items,
            useForm,
            itemsKey,
            width: 220,
            sorter: false,
            customRenderInputProp: ({ record, key }) => lodash.merge(
                {
                    disabled: true,
                    addonAfter: () => {
                        return <div>{record?.refPackagingCharacteristic?.value}</div>
                    },
                },
                conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
            )
        }),
        createColumnInlineInputNumber({
            title: () => i18n.global.t("views.request.releaseResultProduct.qty"),
            dataIndex: "qty",
            items,
            useForm,
            itemsKey,
            width: 150,
            sorter: false,
            customRenderInputProp: ({ record, key }) => lodash.merge(
                {
                    disabled: true,
                    addonAfter: () => {
                        return <div>{record?.refQtyUnit?.value}</div>
                    },
                },
                conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
            )
        }),
        createColumnInlineRadioGroup({
            title: () => i18n.global.t("views.request.releaseResultProduct.refResult"),
            dataIndex: "refResult",
            items,
            useForm,
            itemsKey,
            width: 180,
            sorter: false,
            inputProp: () => ({ list: callResultType, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callResultType,
                        optLabel: "value",
                        type: "vertical",
                        "onUpdate:value": value => {
                            record.refResult = value;
                            record.isSave = true;
                            if (lodash.some(items, d => !d.refResult)) {
                                modelRef.refReleaseTemp.refResult = null;
                            } else if (lodash.every(items, d => d.refResult?.key === "1")) {
                                modelRef.refReleaseTemp.refResult = data.resultTypes.find(d => d.key === "1");
                            } else if (lodash.some(items, d => d.refResult?.key === "2")) {
                                modelRef.refReleaseTemp.refResult = data.resultTypes.find(d => d.key === "2");
                            } else if (lodash.some(items, d => d.refResult?.key === "3")) {
                                modelRef.refReleaseTemp.refResult = data.resultTypes.find(d => d.key === "3");
                            }
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                ),
        })
    );
    return columns;
};

export const createField = ({ props, data, key }) => {
    const { viewOnly, menuContext } = props;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                visible: () => true,
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}products`,
                            fetchCriteria: data.products?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "UseRateList" } })
                    );
                    return <UseRateList {...componentProp}></UseRateList>;
                }
            }
        ]
    });
};
